import React from 'react';
import { useSelector } from 'react-redux';
import { ensureBackgroundForForeground } from '~/modules/Helper/contrast.helper';
import * as S from './Header.styled';

function Header({ children, leftBar }) {
  const { banner, corTema } = useSelector(state => state.configuration);
  const chipBg = ensureBackgroundForForeground(corTema);

  return (
    <S.Header
      src={banner}
      $hasLeftBar={Boolean(leftBar)}
      style={{ '--header-chip-bg': chipBg }}
      aria-label="Cabeçalho do portal"
    >
      {leftBar && <S.HeaderLeftBar>{leftBar}</S.HeaderLeftBar>}
      {children}
    </S.Header>
  );
}

export default Header;
